import { AxiosPromise } from 'axios';
import { BrandColor } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const loadBrandColors = (): AxiosPromise<BrandColor[]> => {
    const { Accounts } = request();
    return Accounts.accountsDashboardsettingsBrandcolorsGet();
};

export const updateBrandColors = (
    newColors: BrandColor[],
    existingColors?: BrandColor[]
): AxiosPromise<BrandColor[]> => {
    const { Accounts } = request();
    if (existingColors) {
        return Accounts.accountsDashboardsettingsBrandcolorsPut(newColors);
    }
    return Accounts.accountsDashboardsettingsBrandcolorsPost(newColors);
};
